import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.css']
})
export class CheckboxComponent implements OnInit {

  @Input() form_group;
  @Input() controlName;
  @Input() disabled;
  @Input() label;
  @Input() mandatory;
  @Input() field;

  checb;
  constructor() { }

  ngOnInit(): void {
    if (this.form_group.get(this.field.fieldID).value) {
     this.checb =true;
      // this.checb.setValue(true);
    }
  }
  selectedCheckbox(ev) {
    this.form_group.get(this.field.fieldID).setValue((ev.checked ? 1 : 0));
  }
}
